module.exports = __webpack_public_path__ + "static/media/settings.d650f064.svg";